import { Injectable } from '@angular/core';
import { first } from 'rxjs/operators';

import { AnalyticsService } from './analytics.service';
import { ProfileService } from './profile.service';
import { AuthService } from '../../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ReferralTrackingService {
  constructor(
    private readonly analyticsService: AnalyticsService,
    private readonly profileService: ProfileService,
    private readonly authService: AuthService
  ) {}

  saveTrackingParamsToProfile(): void {
    const referralData = this.analyticsService.getTrackingParams();
    if (referralData) {
      this.profileService.updateProfileData({ referral: referralData }).pipe(first()).subscribe();
    }
  }

  checkAndSaveForAuthenticatedUser(): void {
    this.authService.checkUserCredentials().then(() => {
      if (this.authService.userLoaded$.value) {
        this.saveTrackingParamsToProfile();
      }
    });
  }
}
